export interface Supplier {
  id: string
  name: string
  legalName: string
  country: string
  city: string
  category: string
  subcategory: string
  taxId: string
  bankAccountMasked: string
  paymentTerms: string
  categoryOwner: string
  riskScore: number
  riskLevel: 'low' | 'medium' | 'high' | 'critical'
  spendBand: string
  annualSpend: number
  contractValue: number
  openPOs: number
  invoicesDue: number
  complianceExpiry: string
  qualityIncidents: number
  leadTimeDays: number
  serviceLevel: number
  forecastVariance: number
  status: 'active' | 'onboarding' | 'under-review' | 'blocked' | 'inactive'
  onboardingStage?: string
  diversityAttributes: string[]
  esgRating: string
  registrationDate: string
  lastActivityDate: string
  primaryContact: string
  primaryContactEmail: string
  phone: string
  website: string
  supplierType: 'strategic' | 'preferred' | 'approved' | 'provisional' | 'tail'
}

export const suppliers: Supplier[] = [
  {
    id: 'SUP-001',
    name: 'Oceanic Harvest Pte Ltd',
    legalName: 'Oceanic Harvest Private Limited',
    country: 'Singapore',
    city: 'Singapore',
    category: 'Fresh Produce',
    subcategory: 'Seafood & Marine',
    taxId: '201912345A',
    bankAccountMasked: '****6789',
    paymentTerms: 'Net 30',
    categoryOwner: 'Rachel Tan',
    riskScore: 22,
    riskLevel: 'low',
    spendBand: '$5M–$10M',
    annualSpend: 7200000,
    contractValue: 8500000,
    openPOs: 14,
    invoicesDue: 3,
    complianceExpiry: '2026-06-15',
    qualityIncidents: 1,
    leadTimeDays: 3,
    serviceLevel: 97.2,
    forecastVariance: 4.1,
    status: 'active',
    diversityAttributes: ['Local SME'],
    esgRating: 'A',
    registrationDate: '2020-03-15',
    lastActivityDate: '2026-03-14',
    primaryContact: 'James Lim',
    primaryContactEmail: 'james.lim@oceanicharvest.sg',
    phone: '+65 6234 5678',
    website: 'www.oceanicharvest.sg',
    supplierType: 'strategic',
  },
  {
    id: 'SUP-002',
    name: 'Golden Fields Agriculture',
    legalName: 'Golden Fields Agriculture Sdn Bhd',
    country: 'Malaysia',
    city: 'Johor Bahru',
    category: 'Fresh Produce',
    subcategory: 'Fruits & Vegetables',
    taxId: 'MY-2018-77234',
    bankAccountMasked: '****3421',
    paymentTerms: 'Net 45',
    categoryOwner: 'Rachel Tan',
    riskScore: 35,
    riskLevel: 'low',
    spendBand: '$10M–$20M',
    annualSpend: 14500000,
    contractValue: 16000000,
    openPOs: 22,
    invoicesDue: 5,
    complianceExpiry: '2026-09-30',
    qualityIncidents: 0,
    leadTimeDays: 2,
    serviceLevel: 98.5,
    forecastVariance: 2.8,
    status: 'active',
    diversityAttributes: [],
    esgRating: 'A-',
    registrationDate: '2019-07-22',
    lastActivityDate: '2026-03-15',
    primaryContact: 'Ahmad bin Hassan',
    primaryContactEmail: 'ahmad@goldenfields.my',
    phone: '+60 7-234 5678',
    website: 'www.goldenfields.my',
    supplierType: 'strategic',
  },
  {
    id: 'SUP-003',
    name: 'Pacific Meats International',
    legalName: 'Pacific Meats International Pty Ltd',
    country: 'Australia',
    city: 'Melbourne',
    category: 'Meat & Seafood',
    subcategory: 'Chilled & Frozen Meats',
    taxId: 'AU-ABN-45678901',
    bankAccountMasked: '****8812',
    paymentTerms: 'Net 30',
    categoryOwner: 'David Ng',
    riskScore: 18,
    riskLevel: 'low',
    spendBand: '$20M+',
    annualSpend: 28000000,
    contractValue: 30000000,
    openPOs: 31,
    invoicesDue: 8,
    complianceExpiry: '2026-12-01',
    qualityIncidents: 2,
    leadTimeDays: 7,
    serviceLevel: 95.8,
    forecastVariance: 6.2,
    status: 'active',
    diversityAttributes: [],
    esgRating: 'B+',
    registrationDate: '2018-01-10',
    lastActivityDate: '2026-03-13',
    primaryContact: 'Sarah Mitchell',
    primaryContactEmail: 'sarah.m@pacificmeats.com.au',
    phone: '+61 3 9876 5432',
    website: 'www.pacificmeats.com.au',
    supplierType: 'strategic',
  },
  {
    id: 'SUP-004',
    name: 'NutriPack Solutions',
    legalName: 'NutriPack Solutions Pte Ltd',
    country: 'Singapore',
    city: 'Singapore',
    category: 'Packaged FMCG',
    subcategory: 'Snacks & Confectionery',
    taxId: '202034567B',
    bankAccountMasked: '****1155',
    paymentTerms: 'Net 60',
    categoryOwner: 'Michelle Wong',
    riskScore: 41,
    riskLevel: 'medium',
    spendBand: '$1M–$5M',
    annualSpend: 3200000,
    contractValue: 3500000,
    openPOs: 8,
    invoicesDue: 2,
    complianceExpiry: '2026-04-20',
    qualityIncidents: 3,
    leadTimeDays: 5,
    serviceLevel: 92.1,
    forecastVariance: 8.5,
    status: 'active',
    diversityAttributes: ['Women-Owned'],
    esgRating: 'B',
    registrationDate: '2021-05-18',
    lastActivityDate: '2026-03-12',
    primaryContact: 'Linda Chen',
    primaryContactEmail: 'linda@nutripack.sg',
    phone: '+65 6345 6789',
    website: 'www.nutripack.sg',
    supplierType: 'preferred',
  },
  {
    id: 'SUP-005',
    name: 'Evergreen Label Manufacturing',
    legalName: 'Evergreen Label Manufacturing Co Ltd',
    country: 'Thailand',
    city: 'Bangkok',
    category: 'Private Label Manufacturing',
    subcategory: 'Household & Cleaning',
    taxId: 'TH-0105562012345',
    bankAccountMasked: '****7744',
    paymentTerms: 'Net 45',
    categoryOwner: 'Michelle Wong',
    riskScore: 55,
    riskLevel: 'medium',
    spendBand: '$5M–$10M',
    annualSpend: 6800000,
    contractValue: 7200000,
    openPOs: 11,
    invoicesDue: 4,
    complianceExpiry: '2026-05-10',
    qualityIncidents: 1,
    leadTimeDays: 14,
    serviceLevel: 94.3,
    forecastVariance: 5.7,
    status: 'active',
    diversityAttributes: [],
    esgRating: 'B-',
    registrationDate: '2020-11-03',
    lastActivityDate: '2026-03-11',
    primaryContact: 'Somchai Prasert',
    primaryContactEmail: 'somchai@evergreenlabel.co.th',
    phone: '+66 2 345 6789',
    website: 'www.evergreenlabel.co.th',
    supplierType: 'preferred',
  },
  {
    id: 'SUP-006',
    name: 'MedWell Pharma Distribution',
    legalName: 'MedWell Pharma Distribution Pte Ltd',
    country: 'Singapore',
    city: 'Singapore',
    category: 'Pharmacy & Wellness',
    subcategory: 'OTC Pharmaceuticals',
    taxId: '201845678C',
    bankAccountMasked: '****9933',
    paymentTerms: 'Net 30',
    categoryOwner: 'Kevin Teo',
    riskScore: 28,
    riskLevel: 'low',
    spendBand: '$10M–$20M',
    annualSpend: 12500000,
    contractValue: 14000000,
    openPOs: 19,
    invoicesDue: 6,
    complianceExpiry: '2026-08-22',
    qualityIncidents: 0,
    leadTimeDays: 4,
    serviceLevel: 99.1,
    forecastVariance: 1.9,
    status: 'active',
    diversityAttributes: ['Local SME'],
    esgRating: 'A',
    registrationDate: '2019-02-28',
    lastActivityDate: '2026-03-15',
    primaryContact: 'Dr. Priya Nair',
    primaryContactEmail: 'priya@medwellpharma.sg',
    phone: '+65 6456 7890',
    website: 'www.medwellpharma.sg',
    supplierType: 'strategic',
  },
  {
    id: 'SUP-007',
    name: 'RetailFit Solutions',
    legalName: 'RetailFit Solutions Pte Ltd',
    country: 'Singapore',
    city: 'Singapore',
    category: 'Store Fixtures & Facilities',
    subcategory: 'Shelving & Display',
    taxId: '202156789D',
    bankAccountMasked: '****2266',
    paymentTerms: 'Net 60',
    categoryOwner: 'Jason Ong',
    riskScore: 62,
    riskLevel: 'medium',
    spendBand: '$500K–$1M',
    annualSpend: 780000,
    contractValue: 900000,
    openPOs: 3,
    invoicesDue: 1,
    complianceExpiry: '2026-03-31',
    qualityIncidents: 2,
    leadTimeDays: 21,
    serviceLevel: 88.5,
    forecastVariance: 12.3,
    status: 'under-review',
    diversityAttributes: ['Minority-Owned'],
    esgRating: 'C+',
    registrationDate: '2022-06-14',
    lastActivityDate: '2026-03-10',
    primaryContact: 'Marcus Lee',
    primaryContactEmail: 'marcus@retailfit.sg',
    phone: '+65 6567 8901',
    website: 'www.retailfit.sg',
    supplierType: 'approved',
  },
  {
    id: 'SUP-008',
    name: 'SwiftHaul Logistics',
    legalName: 'SwiftHaul Logistics Pte Ltd',
    country: 'Singapore',
    city: 'Singapore',
    category: 'Logistics & Transport',
    subcategory: 'Cold Chain Logistics',
    taxId: '201967890E',
    bankAccountMasked: '****5588',
    paymentTerms: 'Net 30',
    categoryOwner: 'David Ng',
    riskScore: 15,
    riskLevel: 'low',
    spendBand: '$5M–$10M',
    annualSpend: 5400000,
    contractValue: 6000000,
    openPOs: 6,
    invoicesDue: 2,
    complianceExpiry: '2027-01-15',
    qualityIncidents: 0,
    leadTimeDays: 1,
    serviceLevel: 99.5,
    forecastVariance: 0.8,
    status: 'active',
    diversityAttributes: [],
    esgRating: 'A-',
    registrationDate: '2020-08-20',
    lastActivityDate: '2026-03-15',
    primaryContact: 'Tony Koh',
    primaryContactEmail: 'tony@swifthaul.sg',
    phone: '+65 6678 9012',
    website: 'www.swifthaul.sg',
    supplierType: 'preferred',
  },
  {
    id: 'SUP-009',
    name: 'CloudBridge Technologies',
    legalName: 'CloudBridge Technologies Pte Ltd',
    country: 'Singapore',
    city: 'Singapore',
    category: 'Technology & SaaS',
    subcategory: 'Enterprise Software',
    taxId: '202078901F',
    bankAccountMasked: '****4477',
    paymentTerms: 'Net 30',
    categoryOwner: 'Jason Ong',
    riskScore: 20,
    riskLevel: 'low',
    spendBand: '$1M–$5M',
    annualSpend: 2100000,
    contractValue: 2400000,
    openPOs: 2,
    invoicesDue: 1,
    complianceExpiry: '2026-11-30',
    qualityIncidents: 0,
    leadTimeDays: 0,
    serviceLevel: 99.9,
    forecastVariance: 0,
    status: 'active',
    diversityAttributes: ['Local SME'],
    esgRating: 'A',
    registrationDate: '2021-01-05',
    lastActivityDate: '2026-03-14',
    primaryContact: 'Wei Lin Goh',
    primaryContactEmail: 'weilin@cloudbridge.sg',
    phone: '+65 6789 0123',
    website: 'www.cloudbridge.sg',
    supplierType: 'approved',
  },
  {
    id: 'SUP-010',
    name: 'EcoPack Asia',
    legalName: 'EcoPack Asia Co Ltd',
    country: 'Vietnam',
    city: 'Ho Chi Minh City',
    category: 'Sustainability & Packaging',
    subcategory: 'Biodegradable Packaging',
    taxId: 'VN-0312345678',
    bankAccountMasked: '****1199',
    paymentTerms: 'Net 45',
    categoryOwner: 'Michelle Wong',
    riskScore: 48,
    riskLevel: 'medium',
    spendBand: '$500K–$1M',
    annualSpend: 650000,
    contractValue: 750000,
    openPOs: 4,
    invoicesDue: 1,
    complianceExpiry: '2026-07-18',
    qualityIncidents: 1,
    leadTimeDays: 10,
    serviceLevel: 91.2,
    forecastVariance: 9.4,
    status: 'active',
    diversityAttributes: ['Green Certified'],
    esgRating: 'A+',
    registrationDate: '2022-09-12',
    lastActivityDate: '2026-03-09',
    primaryContact: 'Nguyen Thi Mai',
    primaryContactEmail: 'mai@ecopackasia.vn',
    phone: '+84 28 3456 7890',
    website: 'www.ecopackasia.vn',
    supplierType: 'approved',
  },
  {
    id: 'SUP-011',
    name: 'CleanPro Services',
    legalName: 'CleanPro Facility Services Pte Ltd',
    country: 'Singapore',
    city: 'Singapore',
    category: 'Cleaning & Maintenance',
    subcategory: 'Janitorial Services',
    taxId: '201789012G',
    bankAccountMasked: '****3300',
    paymentTerms: 'Net 30',
    categoryOwner: 'Jason Ong',
    riskScore: 72,
    riskLevel: 'high',
    spendBand: '$1M–$5M',
    annualSpend: 1800000,
    contractValue: 2000000,
    openPOs: 5,
    invoicesDue: 3,
    complianceExpiry: '2026-03-20',
    qualityIncidents: 5,
    leadTimeDays: 1,
    serviceLevel: 85.3,
    forecastVariance: 0,
    status: 'active',
    diversityAttributes: [],
    esgRating: 'C',
    registrationDate: '2018-04-30',
    lastActivityDate: '2026-03-15',
    primaryContact: 'Ravi Kumar',
    primaryContactEmail: 'ravi@cleanpro.sg',
    phone: '+65 6890 1234',
    website: 'www.cleanpro.sg',
    supplierType: 'approved',
  },
  {
    id: 'SUP-012',
    name: 'Sunrise Dairy Co-op',
    legalName: 'Sunrise Dairy Cooperative Ltd',
    country: 'New Zealand',
    city: 'Auckland',
    category: 'Fresh Produce',
    subcategory: 'Dairy Products',
    taxId: 'NZ-IRD-12345678',
    bankAccountMasked: '****6622',
    paymentTerms: 'Net 45',
    categoryOwner: 'Rachel Tan',
    riskScore: 12,
    riskLevel: 'low',
    spendBand: '$10M–$20M',
    annualSpend: 11200000,
    contractValue: 12000000,
    openPOs: 16,
    invoicesDue: 4,
    complianceExpiry: '2027-02-28',
    qualityIncidents: 0,
    leadTimeDays: 5,
    serviceLevel: 98.8,
    forecastVariance: 3.1,
    status: 'active',
    diversityAttributes: [],
    esgRating: 'A',
    registrationDate: '2019-11-15',
    lastActivityDate: '2026-03-14',
    primaryContact: 'Emma Thompson',
    primaryContactEmail: 'emma@sunrisedairy.co.nz',
    phone: '+64 9 876 5432',
    website: 'www.sunrisedairy.co.nz',
    supplierType: 'strategic',
  },
  {
    id: 'SUP-013',
    name: 'Bintang Raya Foods',
    legalName: 'PT Bintang Raya Foods',
    country: 'Indonesia',
    city: 'Jakarta',
    category: 'Packaged FMCG',
    subcategory: 'Instant Noodles & Sauces',
    taxId: 'ID-NPWP-01234567890',
    bankAccountMasked: '****8844',
    paymentTerms: 'Net 60',
    categoryOwner: 'Michelle Wong',
    riskScore: 38,
    riskLevel: 'low',
    spendBand: '$5M–$10M',
    annualSpend: 8900000,
    contractValue: 9500000,
    openPOs: 18,
    invoicesDue: 7,
    complianceExpiry: '2026-10-15',
    qualityIncidents: 1,
    leadTimeDays: 8,
    serviceLevel: 96.4,
    forecastVariance: 4.8,
    status: 'active',
    diversityAttributes: [],
    esgRating: 'B+',
    registrationDate: '2019-05-20',
    lastActivityDate: '2026-03-13',
    primaryContact: 'Dewi Sartika',
    primaryContactEmail: 'dewi@bintangraya.co.id',
    phone: '+62 21 5678 9012',
    website: 'www.bintangraya.co.id',
    supplierType: 'preferred',
  },
  {
    id: 'SUP-014',
    name: 'TechServe Asia',
    legalName: 'TechServe Asia Pte Ltd',
    country: 'Singapore',
    city: 'Singapore',
    category: 'Technology & SaaS',
    subcategory: 'IT Infrastructure',
    taxId: '202289012H',
    bankAccountMasked: '****5511',
    paymentTerms: 'Net 30',
    categoryOwner: 'Jason Ong',
    riskScore: 25,
    riskLevel: 'low',
    spendBand: '$500K–$1M',
    annualSpend: 720000,
    contractValue: 800000,
    openPOs: 2,
    invoicesDue: 0,
    complianceExpiry: '2026-12-31',
    qualityIncidents: 0,
    leadTimeDays: 3,
    serviceLevel: 99.7,
    forecastVariance: 0,
    status: 'onboarding',
    onboardingStage: 'Compliance Review',
    diversityAttributes: ['Local SME', 'Veteran-Owned'],
    esgRating: 'B+',
    registrationDate: '2026-02-01',
    lastActivityDate: '2026-03-15',
    primaryContact: 'Daniel Yeo',
    primaryContactEmail: 'daniel@techserve.sg',
    phone: '+65 6901 2345',
    website: 'www.techserve.sg',
    supplierType: 'provisional',
  },
  {
    id: 'SUP-015',
    name: 'FreshCo Trading',
    legalName: 'FreshCo Trading Pte Ltd',
    country: 'Singapore',
    city: 'Singapore',
    category: 'Fresh Produce',
    subcategory: 'Organic Produce',
    taxId: '202390123I',
    bankAccountMasked: '****7700',
    paymentTerms: 'Net 30',
    categoryOwner: 'Rachel Tan',
    riskScore: 0,
    riskLevel: 'low',
    spendBand: 'New',
    annualSpend: 0,
    contractValue: 0,
    openPOs: 0,
    invoicesDue: 0,
    complianceExpiry: 'N/A',
    qualityIncidents: 0,
    leadTimeDays: 0,
    serviceLevel: 0,
    forecastVariance: 0,
    status: 'onboarding',
    onboardingStage: 'Company Details',
    diversityAttributes: ['Green Certified', 'Women-Owned'],
    esgRating: 'Pending',
    registrationDate: '2026-03-10',
    lastActivityDate: '2026-03-15',
    primaryContact: 'Mei Ling Chow',
    primaryContactEmail: 'meiling@freshco.sg',
    phone: '+65 6012 3456',
    website: 'www.freshco.sg',
    supplierType: 'provisional',
  },
]

export function getSupplierById(id: string): Supplier | undefined {
  return suppliers.find((s) => s.id === id)
}

export function getSuppliersByStatus(status: Supplier['status']): Supplier[] {
  return suppliers.filter((s) => s.status === status)
}

export function getSuppliersByCategory(category: string): Supplier[] {
  return suppliers.filter((s) => s.category === category)
}

export function getSuppliersByRisk(level: Supplier['riskLevel']): Supplier[] {
  return suppliers.filter((s) => s.riskLevel === level)
}
